import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-user-dialog',
 
  templateUrl: './user-dialog.component.html',
  styleUrl: './user-dialog.component.css'
})
export class UserDialogComponent {
userForm: FormGroup;
 staffList: any[] = [];
  constructor(
     private apiService: ApiService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<UserDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data)
    this.userForm = this.fb.group({
      id: [data?.id ? (Array.isArray(data.id) ? data.id : [data.id]) : [], Validators.required],
      start_date: [data?.start_date ||'' , Validators.required],
      end_date: [data?.end_date || '', Validators.required],
    });

    const params = { keyword: "" };
    this.apiService.getStaff(params).subscribe({
      next: (res: any) => {
        console.log(res);

        this.staffList = res.data;
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => console.log("Observable complete"),
    });
  
  }



  // save(): void {
  //   if (this.userForm.valid) {
  //     this.dialogRef.close(this.userForm.value);
  //   }
  // }
    save() {
    if (this.userForm.valid) {
      this.dialogRef.close({ ...this.data, ...this.userForm.value });
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}